import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codegiant/app/register/register.tsx");
